import { render, staticRenderFns } from "./GraphCalendar.vue?vue&type=template&id=35585c04"
import script from "./GraphCalendar.vue?vue&type=script&lang=js"
export * from "./GraphCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35585c04')) {
      api.createRecord('35585c04', component.options)
    } else {
      api.reload('35585c04', component.options)
    }
    module.hot.accept("./GraphCalendar.vue?vue&type=template&id=35585c04", function () {
      api.rerender('35585c04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/reporting/GraphCalendar.vue"
export default component.exports